// Homepage FAQ. These target the long-tail questions people actually type
// before hiring locally ("how much does pressure washing cost in Clinton NC",
// "do I need to be home"), and feed the FAQPage schema on the homepage.
export const homeFaq = [
  {
    question: "How much does pressure washing cost in Clinton, NC?",
    answer:
      "Pricing depends on the size of the property, the surfaces being cleaned, and how much buildup is present. A single-story house wash is priced differently than a roof wash or a large concrete driveway. We give free, no-obligation quotes so you know the exact price before any work starts.",
  },
  {
    question: "What is the difference between pressure washing and soft washing?",
    answer:
      "Pressure washing uses high water pressure and is right for hard surfaces like concrete driveways, sidewalks, and patios. Soft washing uses low pressure with cleaning solutions that kill algae and mildew at the root, and it is the safe choice for vinyl siding, painted surfaces, and shingle roofs. Using high pressure on siding or a roof can cause real damage, so we match the method to the surface.",
  },
  {
    question: "How often should a house in Sampson County be washed?",
    answer:
      "Most homes in this part of North Carolina benefit from a wash every one to two years. Our humidity and long warm season let green algae and black mildew build up quickly, especially on north-facing walls and shaded areas under trees.",
  },
  {
    question: "Do I need to be home during the service?",
    answer:
      "No. As long as we have access to the areas being cleaned and an outdoor water spigot, we can complete most jobs while you are at work. We will walk you through the results afterward or send photos if you prefer.",
  },
  {
    question: "Are your cleaning solutions safe for plants and pets?",
    answer:
      "Yes, when applied correctly. We pre-wet and rinse surrounding landscaping and use properly diluted solutions. We ask that pets stay inside while we are working, and everything is safe once the surfaces have dried.",
  },
  {
    question: "Which areas do you serve around Clinton?",
    answer:
      "Clinton is our home base. We regularly serve Roseboro, Newton Grove, Salemburg, Garland, Turkey, Warsaw, and Dunn, along with the rest of Sampson County. If you are just outside that range, call us and we will let you know if we can fit you in.",
  },
  {
    question: "How long does a typical job take?",
    answer:
      "A standard single-story house wash usually takes two to four hours. Larger homes, roof washing, or combined house-and-driveway jobs can take most of a day. We will give you a realistic time window when we quote the work.",
  },
];
